<template><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.25 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V4.58333C2.75 4.0971 2.94315 3.63079 3.28697 3.28697C3.63079 2.94315 4.0971 2.75 4.58333 2.75H8.25"
            stroke="currentColor" stroke-opacity="0.9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.667 15.5837L19.2503 11.0003L14.667 6.41699" stroke="currentColor" stroke-opacity="0.9" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        <path d="M19.25 11H8.25" stroke="currentColor" stroke-opacity="0.9" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>